import * as React from 'react';
import moment from 'moment';
import Icon from 'antd/lib/icon';
import GenericHoc from 'src/components/hoc/GenericHoc';
import Loader from 'src/components/common/Loader';
import Timeline from 'antd/lib/timeline';
import { Button, Input, Modal, Table } from "antd";
import { StylesProps } from 'src/Library/Types';
import { fetchCouriersOfShipment, getCourierTracking, getElegibleCouriersPartners } from 'src/api/shipmentExecution';
import { statusPrettyNameMap } from './tracking.constants';
import { courierTrackingStyles } from './tracking.styles';
import { snakeToPretty } from 'src/Library/Helper';
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import GetExecutionData from 'src/dto/response/getExecution';
import { render } from '@testing-library/react';
import { TableProps } from 'antd/lib/table';
import { CourierTrackingFetch } from './tracking.types';
import FormItem from 'antd/lib/form/FormItem';
import form from 'antd/lib/form';

const noDocumentsImg = require('src/assets/images/noDocuments.png');

interface IProps extends StylesProps<typeof courierTrackingStyles> {
    selectedShipment: GetExecutionData;
    //loadShipments: async () => CourierTrackingFetch[];
}

const CourierTrackingV2 = (props: IProps) => {
    const { classes, selectedShipment } = props;
    const [loading, setLoading] = React.useState<boolean>(true);
    const [trackingData, setTrackingData] = React.useState<CourierTrackingFetch[] | undefined>();
    const [expandedRowKeys, setExpandedRowKeys] = React.useState<string[]>([]);
    const [supportedCarriers, setSupportedCarriers] = React.useState<any[]>([]);
    const [isSaving, setisSaving] = React.useState<boolean>(false);
    const [awbNumber, setAwbNumber] = React.useState<string>("");
    const [courierPartner, setCourierPartner] = React.useState<string>("");

    const loadCourierItems = async () => {
        setLoading(true);
        const result = await fetchCouriersOfShipment(selectedShipment.id);
        if (result.isSuccess) {
            result?.data.forEach(item => {
                item.key = item.id
            })
            //console.log(result.data)
            setTrackingData(result.data);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        //console.log(selectedShipment.id);
        if (!selectedShipment.id) {
            return;
        }
        loadCourierItems();
    }, [selectedShipment.id]);


    const getLabel = (label) => {
        return <div className={classes.label}>{label}</div>
    }

    const handleExpand = (record: CourierTrackingFetch) => {
        const keys = [...expandedRowKeys];
        const index = keys.indexOf(record?.key);
        if (index >= 0) {
            keys.splice(index, 1);
        } else {
            keys.push(record?.key);
        }
        setExpandedRowKeys(keys);
    };

    const handleCourierPartner = (val) => {
        setCourierPartner(val);
    }

    const handleAwbNumberInput = (val) => {
        setAwbNumber(val);
    }

    const courierPartnerCode = () => {
        return (
            <Input
                maxLength={3}
                placeholder={'Code'}
                //value={airLineCode}
                onChange={(val) => {
                    handleCourierPartner(val.target.value);
                }}
            />
        );
    }

    const awbNumberInput = () => {
        return (
            <Input
                maxLength={3}
                placeholder={'Code'}
                //value={airLineCode}
                onChange={(val) => {
                    handleAwbNumberInput(val.target.value);
                }}
            />
        );
    }

    const renderAddCourier = () => {
        return (
            <>
                {getLabel('AWB Number*')}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <FormItem style={{ maxWidth: 75 }}>
                        {courierPartnerCode()}
                    </FormItem>
                    <FormItem style={{ marginLeft: 4 }}>
                        {awbNumberInput()}
                    </FormItem>
                </div>
            </>
        );
    };


    const columns: TableProps<CourierTrackingFetch>['columns'] = [
        {
            title: "Courier Partner",
            render: (_, record) => (
                <div>
                    <img className={classes.logoImg} src={record?.logo_url}></img>
                    {record?.code}
                </div>
            )
        },
        {
            title: "Tracking Number",
            dataIndex: 'courier_reference_number',
            // render: (text) => <div>{text}</div>
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => <a onClick={() => handleExpand(record)}>
                View Details
            </a>,
        },
    ];

    const getSupportedCouriers = async () => {
        setLoading(true);
        const result = await getElegibleCouriersPartners();
        setSupportedCarriers(result);
        setLoading(false);
    }

    // React.useEffect(() => {
    //     getSupportedCouriers();
    // }, [selectedShipment.id]);

    const renderTable = () => {
        return (
            <Table
                className={classes.masterTable}
                columns={columns}
                dataSource={trackingData}
                expandedRowKeys={expandedRowKeys}
                // expandIcon={customExpandIcon}
                onExpand={(expanded, record) => handleExpand(record)}
                expandedRowRender={(record) => (
                    <iframe
                        src={record?.iframe_url}
                        width="100%"
                        height="300px"
                        title="example"
                    />
                )}
            />
        )
    }

    return <React.Fragment>
        {renderTable()}
    </React.Fragment>;
}

const options: HocOptions = {
    connectJss: {
        useJss: true,
        styleSheet: courierTrackingStyles,
    },
};

const CourierV2 = GenericHoc(options)(CourierTrackingV2);
export default CourierV2;
